import { useEffect, useRef, useState } from "react";

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export function useVersionCheck() {
  const initialBuildTime = useRef<number | null>(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const res = await fetch("/version.json", { cache: "no-store" });
        if (!res.ok) return;
        const data = await res.json();
        const buildTime: number = data.buildTime;

        if (initialBuildTime.current === null) {
          initialBuildTime.current = buildTime;
          return;
        }

        if (buildTime !== initialBuildTime.current) {
          setUpdateAvailable(true);
        }
      } catch {
        // network errors — ignore silently
      }
    };

    fetchVersion();
    const interval = setInterval(fetchVersion, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  return updateAvailable;
}
